<template>
    <div>
        <b-form-group :description="helpText"
                      :state="isValid"
                      :invalid-feedback="invalidFeedback"
                      :label="fieldLabel">
            <template v-slot:label>
                <label class="form-label">
                    {{ fieldLabel }}:
                </label>
            </template>
            <b-form-radio-group
                    :checked="value"
                    @change="changeValue"
                    :state="isValid"
                    :name="fieldName"
                    :options="options"
                    :stacked="stacked"/>
        </b-form-group>
    </div>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";
    import {capitalizeFilter} from "@/utils/formatting";

    export default {
        name: "RadioCheckboxField",
        mixins: [fieldMixin],
        props: {
            stacked: {
                type: Boolean,
                default: false
            },
            nullable: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            options() {
                let options = [
                    {text: capitalizeFilter(this.$t('utils.yes')), value: true},
                    {text: capitalizeFilter(this.$t('utils.no')), value: false},
                ];
                if (this.nullable) {
                    options.push({text: capitalizeFilter(this.$t('utils.noResponse')), value: null});
                }
                return options;
            }
        },
    };
</script>

<style scoped>

</style>